import { cva } from 'class-variance-authority';

export const passedCellRootVariants = cva('flex w-full min-w-0 flex-1 flex-col gap-3');

export const passedCellBarVariants = cva('min-w-0 flex-1 [&_[role=progressbar]]:h-5');

export const passedCellCountVariants = cva(
  'text-[14px] font-semibold leading-snug tabular-nums text-foreground'
);

export const passedCellPercentVariants = cva(
  'w-10 shrink-0 text-right text-[12px] font-normal not-italic leading-snug text-[#5c6166]'
);
